import { getTravleDetail } from '@/axios/api'

const travleDetail = {
  state: {
    travleDetail: {}
  },
  mutations: {
    SET_DETAIL (state, travleDetail) {
      state.travleDetail = travleDetail
    }
  },
  actions: {
    TRAVLEDETAIL ({ commit }, params) {
      getTravleDetail(params).then(res => {
        this.state.travleDetail = res.data.data
        // localStorage.setItem('travleDetail', JSON.stringify(this.state.travleDetail))
      })
    }
  }
}

export default travleDetail



// WEBPACK FOOTER //
// ./src/store/modules/getTravleDetail.js